import Swiper, {
    Navigation,
    Pagination,
    Thumbs,
    Autoplay,
    Scrollbar,
    Zoom,
} from 'swiper';

Swiper.use([Navigation, Pagination, Thumbs, Autoplay, Scrollbar, Zoom]);

export default class Slider {
    swiper$;

    get swiper() {
        return this.swiper$;
    }

    set swiper(value) {
        this.swiper$ = value;
    }

    constructor(element, options) {
        const {on: swiperEvents, wrapperElement, ...others} = options;
        const sliderOptions = {
            ...{
                slidesPerView: 1,
                watchSlidesVisibility: true,
                spaceBetween: 32,
                speed: 500,
                loop: false,
                a11y: {
                    prevSlideMessage: 'Zurück',
                    nextSlideMessage: 'Nächste',
                },
                on: {
                    init: (swiper) => Slider.attachFocusHandler(swiper),
                    ...swiperEvents,
                },
                navigation: {
                    nextEl: wrapperElement.querySelector('.swiper-button-next'),
                    prevEl: wrapperElement.querySelector('.swiper-button-prev'),
                },
            },
            ...others,
        };

        this.swiper = new Swiper(element, sliderOptions);
    }

    static attachFocusHandler(swiper) {
        const {slides} = swiper;

        slides.forEach((slide, index) => {
            slide.addEventListener('focusin', () => {
                if (swiper.realIndex !== index) {
                    swiper.slideTo(index);
                }
            });
        });
    }
}
